export default "__VITE_PUBLIC_ASSET__46610b18__"